export default {
    //记录所有用户点击过的导航，包括之前有重复的点击
    setActiveNav(state,navData){
        state.active_nav.push( navData );
    },
    //替换整个active_nav
    checkAllActiveNav(state,navData){
      state.active_nav = navData;
    },
    //当前点击的导航的cusindex
    setiNow(state,iNow){
      state.active_iNow = iNow;
    },
    //pub-head中导航和tab的对应数据
    settabVisible(state,data){
        state.tabVisible.push( data );
    },
    //整体替换vueX中的tabVisible
    checkAllTabVisible(state,tabData){
      state.tabVisible = tabData;
    },
    //设置点击tab标签的高亮
    setActiveTab(state,data){
      for( var i=0;i<state.tabVisible.length;i++ ){
        state.tabVisible[i].isActive = false;
      }
      for( var i=0;i<state.tabVisible.length;i++ ){
        if( state.tabVisible[i].cusindex == data ){
          state.tabVisible[i].isActive = true;
        }
      }
    },
    //设置在售机型tab标签的machineNewOnOff
    setMachineNewOnOff(state,bool){
      state.machineNewOnOff = bool;
    },

    //车型数据授权->查看记录 子项tab页打开，则将该子项目的cusindex存入
    setCarData(state,data){
      state.carData.push(data);
    },
    //车型数据授权->查看记录 替换整个carData
    checkAllCarData(state,data){
      state.carData = data;
    },
    //车型数据授权->查看记录 某子项tab页关闭，则将该子项的cusindex清除
    delCarData(state,data){
      for( var i=0;i<state.carData.length;i++ ){
        if( state.carData[i] == data ){
          state.carData.splice(i,1);
        }
      }
    },

    //用户管理->用户账号列表 子项tab页打开，则将该子项目的cusindex存入
    setAccountData(state,data){
      state.accountData.push(data);
    },
    //用户管理->用户账号列表 替换整个carData
    checkAllAccountData(state,data){
      state.accountData = data;
    },
    //用户管理->用户账号列表 某子项tab页关闭，则将该子项的cusindex清除
    delAccountData(state,data){
      for( var i=0;i<state.accountData.length;i++ ){
        if( state.accountData[i] == data ){
          state.accountData.splice(i,1);
        }
      }
    },


    //用户管理->用户账号列表->产品保修信息 子项tab页打开，则将该子项目的cusindex存入
    setProductWarranty(state,data){
      state.productWarranty.push(data);
    },
    //用户管理->用户账号列表->产品保修信息 替换整个productWarranty
    checkAllProductWarranty(state,data){
      state.productWarranty = data;
    },
    //用户管理->用户账号列表->产品保修信息 某子项tab页关闭，则将该子项的cusindex清除
    delProductWarranty(state,data){
      for( var i=0;i<state.productWarranty.length;i++ ){
        if( state.productWarranty[i] == data ){
          state.productWarranty.splice(i,1);
        }
      }
    },


    //用户管理->用户账号列表->授权 子项tab页打开，则将该子项目的cusindex存入
    setProductAuthorize(state,data){
      state.productAuthorize.push(data);
    },
    //用户管理->用户账号列表->授权 替换整个productAuthorize
    checkAllProductAuthorize(state,data){
      state.productAuthorize = data;
    },
    //用户管理->用户账号列表->授权 某子项tab页关闭，则将该子项的cusindex清除
    delProductAuthorize(state,data){
      for( var i=0;i<state.productAuthorize.length;i++ ){
        if( state.productAuthorize[i] == data ){
          state.productAuthorize.splice(i,1);
        }
      }
    },


    //用户管理->用户账号列表->授权->授权记录 子项tab页打开，则将该子项目的cusindex存入
    setHistoryAuthorize(state,data){
      state.historyAuthorize.push(data);
    },
    //用户管理->用户账号列表->授权->授权记录 替换整个productAuthorize
    checkAllHistoryAuthorize(state,data){
      state.historyAuthorize = data;
    },
    //用户管理->用户账号列表->授权->授权记录 某子项tab页关闭，则将该子项的cusindex清除
    delHistoryAuthorize(state,data){
      for( var i=0;i<state.historyAuthorize.length;i++ ){
        if( state.historyAuthorize[i] == data ){
          state.historyAuthorize.splice(i,1);
        }
      }
    },


    //在登陆的时候改变这个值为true;但是刷新的时候，我们不改变，即为false
    setPageRefreshOnOff(state,bool){
      state.pageRefreshOnOff = bool;
    },
    //设置某个tab标签的隐藏
    setHideTab(state,data){
      var vehicle_reg = /^vehicle/;
      var account_reg = /^account/;
      var warranty_reg = /^warranty/;
      var authorize_reg = /^authorize/;
      var record_reg = /^record/;
      var marchine_reg = /^machine/;
      for( var i=0;i<state.tabVisible.length;i++ ){
        if( vehicle_reg.test( data )
          || account_reg.test( data )
          || warranty_reg.test( data )
          || authorize_reg.test( data )
          || record_reg.test( data )
          || marchine_reg.test( data ) ){//如果删除的是新加的machine,则从数组中删除
          if( state.tabVisible[i].cusindex == data ){
            state.tabVisible.splice(i,1);
          }
        }else{//否则隐藏
          if( state.tabVisible[i].cusindex == data ){
            state.tabVisible[i].orShow = false;
          }
        }
      }
    },
    //当删除标签页的时候，同时需要相应地删除active_nav
    changeActiveNav(state,navData){
      //从state.active_nav删除navData,不过先要去重
      var duplicate = state.active_nav;
      var array_temp = [];
      for (var i = 0, l = duplicate.length; i < l; i++) {
        for (var j = i + 1; j < l; j++)
          if (duplicate[i] === duplicate[j]) j = ++i;
            array_temp.push(duplicate[i]);
      }

      for( var i=0;i<array_temp.length;i++ ){
        if( array_temp[i] == navData ){
          array_temp.splice( i,1 );
        }
      }
      state.active_nav = array_temp;
    },
    emptyNav(state){
      state.active_nav = [];
    },
    //tab页签右键关闭其它，active_nav只存储点击的cusindex
    setOnlyNav(state,cusindex){
      var vehicle_reg = /^vehicle/;
      var account_reg = /^account/;
      var warranty_reg = /^warranty/;
      var authorize_reg = /^authorize/;
      var record_reg = /^record/;
      var marchine_reg = /^machine/;
      state.active_nav = [];
      state.active_nav.push( cusindex );
      state.carData = [];
      state.accountData = [];
      state.productWarranty = [];
      state.productAuthorize = [];
      state.historyAuthorize = [];

      if( vehicle_reg.test( cusindex ) ){
        state.carData.push(cusindex);
      }else if( account_reg.test( cusindex ) ){
        state.accountData.push(cusindex);
      }else if( warranty_reg.test( cusindex ) ){
        state.productWarranty.push(cusindex);
      }else if( authorize_reg.test( cusindex ) ){
        state.productAuthorize.push(cusindex);
      }else if( record_reg.test( cusindex ) ){
        state.historyAuthorize.push(cusindex);
      }else if( marchine_reg.test( cusindex ) ){
        state.machineNewOnOff = false;
      }

    },
    //tab页签右键关闭其它，tabVisible中只有点击的cusindex的orShow和isActive等于true
    setOnlyShowNav(state,cusindex){
      console.log(cusindex);
      //先判断点击的cusindex是否在原始的tabVisible中，比如历史记录，售机类型配置，维修记录都不在原始的tabVisible中
      var onoff = false;
      for( var i=0;i<state.tabVisible_original.length;i++ ){
        if( state.tabVisible_original[i].cusindex == cusindex ){
          onoff = true;
        }
      }
      //车型数据授权tab页、用户账号列表tab页
      var obj_temp = {};
      if( !onoff ){
        for( var i=0;i<state.tabVisible.length;i++ ){
          if( state.tabVisible[i].cusindex == cusindex ){
            obj_temp = state.tabVisible[i];//选取这些特定的对象集
            break;
          }
        }
      }
      console.log(obj_temp);

      state.tabVisible = JSON.parse( JSON.stringify( state.tabVisible_original ) );//重置tabVisible
      console.log(state.tabVisible);
      if( onoff ){//如果原始tabVisible中有
        for( var i=0;i<state.tabVisible.length;i++ ){
          if( state.tabVisible[i].cusindex == cusindex ){
            state.tabVisible[i].orShow = true;
            state.tabVisible[i].isActive = true;
          }
        }
      }else{
        for( var i=0;i<state.tabVisible.length;i++ ){
          state.tabVisible[i].orShow = false;
          state.tabVisible[i].isActive = false;
        }
        state.tabVisible.push(obj_temp);
      }

    },
    resetAllData(state){
      state.active_nav = [];
      state.active_iNow = "";
      state.carData = [];
      state.accountData = [];
      state.productWarranty = [];
      state.productAuthorize = [];
      state.historyAuthorize = [];
      state.machineNewOnOff = true;
      state.pageRefreshOnOff = false;
      state.tabVisible = JSON.parse( JSON.stringify( state.tabVisible_original ) );
    }
}



// WEBPACK FOOTER //
// ./src/assets/vuex/mutations.js